import Vue from "vue";
import App from "./App.vue";
import router from "./router/guards.js";
import store from "./store";
import wmsMessage from "./utils/message";
import wmsPrint from "@/components/choosePrint/index.js";
import WmsTable from "@/components/WmsTable";
import FormUpload from "@/components/FormUpload";
import "@/plugins/arms.js";
// import { wmsAutoPrintInt } from "@/utils/autoPrint";
// wmsAutoPrintInt()
import { printSheet, printPkg, printContainer } from "@/utils/autoPrint";
Vue.config.productionTip = false;

// element
import { MessageBox } from "element-ui";
import EUI from "@/plugins/elment";
import "element-ui/lib/theme-chalk/index.css";
import 'ant-design-vue/dist/antd.css';
EUI.forEach((eUI) => {
  Vue.use(eUI);
});
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$message = wmsMessage;
Vue.prototype.$wmsPrint = wmsPrint;
Vue.prototype.$ELEMENT = { size: "small", zIndex: 3000 };
Vue.prototype.$printSheet = printSheet;
Vue.prototype.$printPkg = printPkg;
Vue.prototype.$printContainer = printContainer;

// img Previewe
import VueDirectiveImagePreviewer from "vue-directive-image-previewer";
import "vue-directive-image-previewer/dist/assets/style.css";
Vue.use(VueDirectiveImagePreviewer);
Vue.component('WmsTable', WmsTable)
Vue.component('FormUpload', FormUpload)
import ImgPreviews from "@/components/ImgPreviews";
Vue.component('ImgPreviews', ImgPreviews)
// lazyload
import VueLazyLoad from "vue-lazyload";
Vue.use(VueLazyLoad, {
  // preLoad: 1,
  // attempt: 2,
  error: require("./assets/lzayImg/error.png"), // 图片路径错误时加载图片
  loading: require("./assets/lzayImg/loading.png"),
});

// 事件总线
Vue.prototype.$bus = new Vue();
let vue = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

export default vue
